import cx from 'classnames';
import { COVER_PHOTO_CHANGE, COVER_PHOTO_REMOVE, TOPIC_NAME } from 'mk/autogenerated/translations/TopicCoverForm.c484fe96c423f7915fe721e8469f9661'
import { isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import { TopicEntity } from 'mk2/apps/forum/schemas';
import Loading from 'mk2/components/Loading';
import MenuItem from 'mk2/components/menu/MenuItem';
import { FormPageType } from 'mk2/constants';
import Menu from 'mk2/containers/Menu/Menu';
import PhotosUpload, {
    PhotosUploadConfig,
    PhotoUploadType,
    UploadedPhoto,
} from 'mk2/containers/PhotosUpload/PhotosUpload';
import { MKReduxFormInjectedProps, mkReduxFormNew } from 'mk2/helpers/form';
import { isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './TopicCoverForm.mscss';

export const TOPIC_COVER_MENU_MORE = 'TOPIC_COVER_MENU_MORE';

export const TOPIC_COVER_UPLOAD_FORM_NAME = 'TOPIC_COVER_UPLOAD_FORM';

const photosConfig: PhotosUploadConfig = {
    photoType: 'topicCover',
    multiple: false,
    showPhotoCode: false,
    nameForCoverPreview: TOPIC_NAME,
};

export interface TopicCoverFormData {
    photos: UploadedPhoto[];
}

interface OwnProps {
    topic: TopicEntity;
    topicLoadingState: LoadingState;
    className?: string;
    topicCover: React.ReactNode;
    photosField: React.ReactNode;
    requestUser: UserEntity;
    permissions: string[];

    onToggleMenuMore(e);
    onRemove(topicId: number);
    onOpenFileExplorer();
    onSave(values: TopicCoverFormData, topicId: number);
}

type Props = OwnProps;

class TopicCoverFormComponent extends React.Component<Props & MKReduxFormInjectedProps<TopicCoverFormData, Props>> {

    public render() {
        const {
            onToggleMenuMore, onOpenFileExplorer,
            className, requestUser, permissions, topic, topicCover, topicLoadingState,
            currentFormPage, photosField,
        } = this.props;

        let role: string = null;
        if (topic) {
            if (isAuthenticatedAs(requestUser, topic.moderators)) {
                role = 'moderator';
            } else if (permissions.indexOf('forum.can_manage_forum') !== -1) {
                role = 'admin';
            }
        }

        let showTopicCover = 'viewWithoutMenu';
        if (role === 'moderator' || role === 'admin') {
            showTopicCover = 'viewWithMenu';
        }
        if (currentFormPage === FormPageType.ChangeTopicCover) {
            showTopicCover = 'change';
        }

        const topicLoaded = isSuccess(topicLoadingState);
        return (
            <React.Fragment>
                {showTopicCover === 'change' && (
                    <div>
                        <PhotosUpload
                            formName={TOPIC_COVER_UPLOAD_FORM_NAME}
                            nameForCoverPreview={topic ? topic.name : ''}
                            showPhotoCode={false}
                            photoUploadType={PhotoUploadType.COVER_PHOTO}
                        />
                    </div>
                )}
                {showTopicCover === 'viewWithoutMenu' && (
                    topicCover
                )}
                {showTopicCover === 'viewWithMenu' && (
                    <Menu
                        className={cx(styles.TopicCoverForm, className)}
                        menuId={TOPIC_COVER_MENU_MORE}
                        trigger={(
                            <div
                                onClick={!topic.coverPhoto ? onOpenFileExplorer : onToggleMenuMore}
                            >
                                {topicCover}
                            </div>
                        )}
                        triggerShadow={false}
                        dropdownPositionTop="-100%r + 10"
                        dropdownPositionRight="-10"
                    >
                        { topicLoaded ? [
                            <MenuItem
                                label={COVER_PHOTO_CHANGE}
                                key="changeMenuItem"
                                icon="fa-image"
                                onClick={this.handleChangeCoverPhoto}
                            />,
                            <MenuItem
                                label={COVER_PHOTO_REMOVE}
                                key="removeMenuItem"
                                icon="fa-trash"
                                onClick={this.handleRemoveCoverPhoto}
                            />,
                        ] : (
                            <div className={styles.TopicCover__loadingWrapper}>
                                <Loading
                                    error={false}
                                    pastDelay
                                    isLoading
                                    timedOut={false}
                                />
                            </div>
                        )}
                    </Menu>
                )}
                {(showTopicCover === 'viewWithMenu' || showTopicCover === 'change') && (
                    photosField
                )}
            </React.Fragment>
        );
    }

    private handleChangeCoverPhoto = () => {
        const {onOpenFileExplorer} = this.props;
        onOpenFileExplorer();
    };

    private handleRemoveCoverPhoto = () => {
        const {topic, onRemove} = this.props;
        onRemove(topic.id);
    };
}

export const TopicCoverForm = mkReduxFormNew<TopicCoverFormData, Props>({
    formName: TOPIC_COVER_UPLOAD_FORM_NAME,
    photosConfig,
    onValidate: (values) => ({}),
    onSave: (values, props) => props.onSave(values, props.topic.id),
    disableDirtyCheck: true,
})(TopicCoverFormComponent);
